export default class FileConfig {
    public label: string = 'Arrastre el archivo aquí...';
    get allowedFileTypesSeparatedByCommas(): string {
        return this.allowedFileTypes.join(', ');
    }
     
    public labelFileTypeNotAllowed: string = 'El tipo de archivo es inválido.';
    public labelFileExpectedTypes: string = `Se esperan archivos ${this.allowedFileExtensions}.`;
    get invalidFileTypeErrorMessage(): string {
        return this.labelFileTypeNotAllowed + ' ' + this.labelFileExpectedTypes;
    }
    public notAllowExtensions: Array<string> = [
        '.jfif',
    ]
    public invalidFileSizeErrorMessage: string = `El archivo que cargaste sobrepasa el tamaño admitido de 5 MB.`;
    public allowedFilesDetails: string = "";
    constructor(public fileSizeMbLimit: number = 5, 
                public allowedFileTypes: Array<string> = [
                    'image/jpeg',
                    'image/jpg',
                    'image/bmp',
                    'image/png',
                    'application/pdf',
                ]) 
    {
        this.allowedFilesDetails = `Archivos admitidos en un tamaño máximo de ${this.fileSizeMbLimit} MB en los siguientes formatos: ${this.allowedFileExtensions}.`;
    }

    get allowedFileExtensions(): string {
        let  allowedFileTypesLocal: Array<string> = [
            'image/jpeg',
            'image/jpg',
            'image/bmp',
            'image/png',
            'application/pdf',
        ]

        return allowedFileTypesLocal.map(x => {
            const extension: string = x.split('/')[1];
            return '.' + extension; 
        }).join(', ');
    }
};